export var valuesUserTaskTimeTriggerType = ["Percentage", "DaysBeforeEnd", "EveryNthDay", "EveryNthHour"];
/*

*/ 
//# sourceMappingURL=UserTaskTimeTriggerType.js.map